import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const useKeyboardNavigation = ({
  onStartRecording,
  onStopRecording,
  onSendTranscript,
  onResetRecording,
  isRecording,
  hasTranscript,
  isLoading
}) => {
  const { t } = useTranslation('global');
  const handleKeyDown = useCallback((event) => {
    // Предотвращаем срабатывание в полях ввода
    if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
      return;
    }

    switch (event.key) {
      case ' ': // Пробел - начать/остановить запись
        event.preventDefault();
        if (isRecording) {
          onStopRecording();
        } else if (!hasTranscript) {
          onStartRecording();
        }
        break;
      
      case 'Enter': // Enter - отправить или начать запись
        event.preventDefault();
        if (hasTranscript && !isRecording) {
          onSendTranscript();
        } else if (!isRecording && !hasTranscript) {
          onStartRecording();
        }
        break;
      
      case 'Escape': // Escape - сбросить запись
        event.preventDefault();
        if (hasTranscript) {
          onResetRecording();
        }
        break;
      
      case 'r': // R - записать заново
      case 'R':
        event.preventDefault();
        if (hasTranscript) {
          onResetRecording();
        }
        break;
      
      default:
        break;
    }
  }, [onStartRecording, onStopRecording, onSendTranscript, onResetRecording, isRecording, hasTranscript]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return {
    // Возвращаем инструкции для пользователя
    keyboardInstructions: [
      t('voice.spaceKey'),
      t('voice.enterKey'),
      t('voice.escapeKey'),
      t('voice.rKey')
    ]
  };
};

export default useKeyboardNavigation;
